<template>
  <div class="ja-login">
    <div class="header">
      <img :src="ICON_LOGO" alt="JAサイネージロゴ" class="header-logo" />
    </div>
    <h1 class="title">ログイン</h1>
    <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
    <div class="login-form">
      <div>
        <label for="userId" class="form-label">
          アカウントID<span class="required">必須</span>
        </label>
        <input
          type="text"
          name="userId"
          class="form-input"
          id="userId"
          placeholder="入力してください"
          v-model="userId"
        />
      </div>
      <div>
        <label for="password" class="form-label">
          パスワード<span class="required">必須</span>
        </label>
        <div class="input-password-wrapper">
          <input
            :type="isPasswordVisible ? 'text' : 'password'"
            name="password"
            class="form-input input-password"
            id="password"
            placeholder="入力してください"
            v-model="password"
          />
          <button
            class="password-visible-change-button"
            @click="isPasswordVisible = !isPasswordVisible"
          >
            <img
              class="password-visible-icon"
              :src="
                require('@/assets/images/' +
                  (isPasswordVisible ? PASSWORD_INVISIBLE_ICON : PASSWORD_VISIBLE_ICON))
              "
              alt="password invisible or visible icon"
            />
          </button>
        </div>
      </div>
      <small-button
        class="small-button"
        title="ログイン"
        :disabled="isFormInvalid"
        @click="loginFormSubmit"
      />
    </div>
    <div class="footer d-flex p-fixed items-center justify-center">
      {{ COPYRIGHT_STR }}
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import SmallButton from '@/components/common/SmallButton.vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import axios from '@/composable/axios';
import { decodeJwtToJson, handleAxiosCommonException } from '@/composable/common';
import { useI18n } from 'vue-i18n';
import { ICON_LOGO } from '@/composable/constant_common';

const { t } = useI18n();

const HTTP_RESPONSE_CODE = { UNAUTHORIZED: 401 };

// ユーザID
const userId = ref('');
// パスワード
const password = ref('');
// パスワード表示可否
const isPasswordVisible = ref(false);
// パスワード表示時アイコンパス
const PASSWORD_VISIBLE_ICON = 'IconVisible.svg';
// パスワード非表示時アイコンパス
const PASSWORD_INVISIBLE_ICON = 'IconInvisible.svg';
// エラーメッセージ
const errorMessage = ref('');
// axios処理待ち
const isAxiosWait = ref(false);

const isFormInvalid = computed(() => {
  return userId.value === '' || password.value === '';
});

const router = useRouter();
const store = useStore();

function loginFormSubmit() {
  if (isAxiosWait.value) return;

  if (isFormInvalid.value) {
    errorMessage.value = 'アカウントID・パスワードは必須です';
    return;
  }

  isAxiosWait.value = true;

  const payload = { userId: userId.value, password: password.value };

  axios
    .post('/login', payload)
    .then((res) => {
      // 認証成功
      localStorage.setItem('token', res.headers.authorization);

      const Jwt = localStorage.getItem('token').replace('Bearer ', '');
      const JSONbody = decodeJwtToJson(Jwt);
      store.commit('userInformation/setUserId', JSONbody.sub);
      store.commit('userInformation/setUserName', res.data.userName);
      store.commit('userInformation/setIsHorizontalDisplay', res.data.isHorizontalDisplay);

      router.push('/ja/home');
    })
    .catch((error) => {
      if (error.response && error.response.status === HTTP_RESPONSE_CODE.UNAUTHORIZED) {
        errorMessage.value = t('message.SIGNAGE002E');
      } else {
        handleAxiosCommonException(error);
      }
    })
    .finally(() => {
      isAxiosWait.value = false;
    });
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ja-login {
  width: 90%;
  margin: auto;
}
.header {
  margin: 3rem 0;
}
.header-logo {
  width: 18rem;
}
.title {
  text-align: left;
  font-size: 3.2rem;
}
.error-message {
  padding: 2rem;
  border-radius: 1rem;
  color: red;
  background-color: #ffeeee;
}
.login-form {
  width: 100%;
}
.login-form > div {
  margin-top: 2rem;
}
.form-label,
.error-message {
  font-size: 1.6rem;
}
.required {
  margin-left: 1rem;
  color: red;
}
.form-input {
  padding: 1.7rem;
  width: 100%;
  box-sizing: border-box;
  font-size: 1.8rem;
}
.small-button {
  text-align: center;
  margin-top: 2rem;
  cursor: pointer;
}
.small-button:hover {
  opacity: 0.8;
}
.password-visible-change-button {
  height: 5rem;
  width: 5rem;
  background-color: inherit;
  border: none;
}
.password-visible-change-button > * {
  height: 100%;
  width: 100%;
}
.input-password-wrapper {
  position: relative;
}
.input-password {
  padding-right: 5.5rem;
}
.password-visible-change-button {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}
.footer {
  bottom: 0;
  left: 0;
  right: 0;
  height: 5vh;
  height: 5dvh;
  width: 100vw;
  background: #fff;
  border: 1px #eee solid;
  z-index: 2;
  font-size: 1.2rem;
}
</style>
